import { useCallback, useMemo } from 'react'

import { IconButton } from '../../common/IconButton'

import { MainPanelWrapper } from './MainPanelWrapper'

interface MainPanelActionProps {
  icon: string
  disabled?: boolean
  onTrigger: () => void
}

export const MainPanelAction = ({
  icon,
  disabled = false,
  onTrigger,
}: MainPanelActionProps) => {
  const handleClick = useCallback(() => {
    if (onTrigger) {
      onTrigger()
    }
  }, [onTrigger])

  const style = useMemo(() => {
    if (disabled) {
      // Dirty workaround because IconButton doesn't support disabled very well
      return { opacity: 0.5, backgroundColor: 'unset' }
    }
  }, [disabled])

  return (
    <MainPanelWrapper>
      <IconButton
        icon={icon}
        style={style}
        size={32}
        onClick={handleClick}
        disabled={disabled}
      />
    </MainPanelWrapper>
  )
}
